import FormComp from "../../Componentes/FormComp";
import Formulario from "../../Componentes/Utils/Formulario";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import SmallLoading from "../../Componentes/Utils/SmallLoading"
import { useModal } from "../../contexts/ModalContext";
import { useEffect, useState } from "react";
import styled from "styled-components";

import { GoSearch } from "react-icons/go";

import useApi from "../../hooks/useApi";
const SectionColabs = styled.div`
    margin-top: 25px;
    padding: 20px;
    background: #f6f8fa;
    border-radius: 12px;
`
const Title = styled.h3`
    margin: 0 0 15px 0;
    color: #263a4a;
    font-size: 18px;
`;
const Row = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 12px;
    overflow: hidden;
    background-color: #fff;

    input {
        box-sizing: border-box;
        padding: 15px;
        flex: 1;
        border: none;
        outline: none;
    }
`
const ContainerIconSearch = styled.div`
    width: 25px;
    height: 25px;
    margin-right: 15px;
`
const IconeSearch = styled(GoSearch)`
    width: 100%;
    height: 100%;
    color: #000;
    cursor: pointer;
`
const Preview = styled.div`
    background: #e9f5ff;
    border: 1px solid #b6daf6;
    padding: 12px;
    border-radius: 8px;
    margin: 10px 0 20px 0;
    color: #0b3d62;

    strong {
        font-size: 15px;
    }
`;
const AddButton = styled.button`
    width: 100%;
    margin-top: 12px;
    padding: 12px;
    background-color: #263a4a;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.2s;
    font-size: 15px;

    &:hover {
        background-color: #1c2d38;
    }

    &:disabled {
        background: #adb5bd;
        cursor: not-allowed;
    }
`;
const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 15px 0 0 0;
`;

const Item = styled.li`
    background: #fff;
    padding: 12px 15px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    span {
        font-weight: 500;
        color: #333;
    }

    button {
        background: #d9534f;
        border: none;
        color: white;
        padding: 6px 12px;
        border-radius: 6px;
        cursor: pointer;
        transition: 0.2s;

        &:hover {
            background: #c9302c;
        }
    }
`;

const AddTreinamentoModal = ({ adicionarTreinamentos }) => {
    const api = useApi();


    const { closeModal, openModal } = useModal();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [obras, setObras] = useState([]);
    const [contratos, setContratos] = useState([]);
    const [instrutores, setInstrutores] = useState([])

    const fetchData = async () => {
        setLoading(true);

        try {
            const [obrasRes, contratosRes, instrutoresRes] = await Promise.all([
                api.get('/Painel/API/GetObrasAtivas/'),
                api.get('/Painel/API/GetContratosAtivos/'),
                api.get('/Painel/API/Treinamentos/GetInstrutores/')
            ])

            setObras(obrasRes.data.map(obj => obj.OBRA))
            setContratos(contratosRes.data)
            setInstrutores(
                instrutoresRes.data
                    .map(obj => ({ value: obj.identifier, label: obj.nome }))
            );

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false)
        }
    }

    const [listContratos, setListContratos] = useState([]);

    const [matricula, setMatricula] = useState('');

    useEffect(() => {
        fetchData();
    }, [])

    const [fetchingMat, setFetchingMat] = useState(false);
    const [preview, setPreview] = useState(false);
    const [previewColab, setPreviewColab] = useState({});

    const [selectedColabs, setSelectedColabs] = useState([]);

    const fetchMatricula = async () => {

        if (matricula.length !== 6) {
            alert('A matricula deve haver 6 digitos.')
            return;
        }
        setFetchingMat(true);

        try {
            const { data } = await api.get(`/Painel/API/Treinamentos/GetColabMat/index.php?matricula=${matricula}`);
            console.log(data);

            setPreview(true);
            setPreviewColab(data);
        } catch (e) {
            console.log(e);
        } finally {
            setFetchingMat(false);
        }

    }

    const adicionarColab = (e) => {
        e.preventDefault();

        setSelectedColabs(prev => [...prev, previewColab]);
        setPreviewColab({});
        setPreview(false)
        setMatricula('');
    }

    const removerColab = (e, mat) => {
        e.preventDefault();

        setSelectedColabs(prev => prev.filter(item => item.MATRICULA !== mat))
    }

    const [formValues, setFormValues] = useState({
        centroCusto: "",
        contrato: "",
        motivo: "",
        tipo: "",
        treinamentoMinis: "",
        dataInicio: "",
        processo: "",
        local: "",
        instrutores: []
    })

    const handleChange = (e, name) => {
        const { value } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {

        setFormValues(prev => ({
            ...prev,
            'contrato': ''
        }))

        let filterContratos = contratos.filter(item => item.centro_custo === formValues.centroCusto)
        filterContratos = filterContratos.map(item => item.contrato);
        setListContratos(filterContratos);

    }, [formValues.centroCusto])

    const fecharModal = () => {

        closeModal();
        openModal('addedTreinamentos');

    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedColabs.length === 0) {
            alert("SELECIONE PELO MENOS UM COLABORADOR");
            return;
        }

        setSaving(true);

        try {
            const { data } = await api.post('/Painel/API/Treinamentos/SaveTreinamentosFunc/', {
                colaboradores: selectedColabs,
                formValues: formValues
            })

            console.log(data);
            adicionarTreinamentos( data.itens );
            fecharModal();

        } catch (e) {
            console.error(e);
        } finally {
            setSaving(false)
        }
    }

    return (
        <Overlay state={true} >
            <Modal header={true} close={closeModal} >
                <Formulario onSubmit={(e) => handleSubmit(e)} >
                    <FormComp
                        title="CENTRO CUSTO"
                        type="select"
                        options={obras}
                        valor={formValues.centroCusto}
                        changeFunc={(e) => handleChange(e, 'centroCusto')}
                        required
                    />
                    <FormComp
                        title="CONTRATO"
                        type="select"
                        options={listContratos}
                        valor={formValues.contrato}
                        changeFunc={(e) => handleChange(e, 'contrato')}
                        required
                    />
                    <FormComp
                        title="MOTIVO"
                        type="select"
                        options={[
                            "COMUNICAÇÃO",
                            "NOVAS RESPONSABILIDADES",
                            "NOVO EMPREGADO",
                            "PROCEDIMENTO/NORMA",
                            "QUALIFICAÇÃO",
                            "RECICLAGEM"
                        ]}
                        valor={formValues.motivo}
                        changeFunc={(e) => handleChange(e, 'motivo')}
                        required
                    />
                    <FormComp
                        title="TIPO"
                        type="select"
                        options={[
                            "COMPLEMENTAR",
                            "EVENTUAL",
                            "INICIAL",
                            "PERIÓDICO"
                        ]}
                        valor={formValues.tipo}
                        changeFunc={(e) => handleChange(e, 'tipo')}
                        required
                    />
                    <FormComp
                        title="TREINAMENTO MINISTRADO"
                        type="select"
                        options={[
                            "EXTERNO",
                            "INTERNO"
                        ]}
                        valor={formValues.treinamentoMinis}
                        changeFunc={(e) => handleChange(e, 'treinamentoMinis')}
                        required
                    />
                    <FormComp
                        title="DATA ÍNICIO"
                        type="date"
                        valor={formValues.dataInicio}
                        changeFunc={(e) => handleChange(e, 'dataInicio')}
                        required
                    />
                    <FormComp
                        title="PROCESSO"
                        type="select"
                        options={[
                            "MEIO-AMBIENTE",
                            "QUALIDADE",
                            "SAÚDE",
                            "SEGURANÇA"
                        ]}
                        valor={formValues.processo}
                        changeFunc={(e) => handleChange(e, 'processo')}
                        required
                    />
                    <FormComp
                        title="LOCAL DO TREINAMENTO"
                        type="select"
                        options={obras}
                        valor={formValues.local}
                        changeFunc={(e) => handleChange(e, 'local')}
                        required
                    />
                    <FormComp
                        title="INSTRUTORES"
                        type="multiselect"
                        placeholder="SELECIONE..."
                        options={instrutores}
                        valor={formValues.instrutores}
                        changeFunc={(selected) =>
                            setFormValues({ ...formValues, instrutores: selected })
                        }
                        required
                    />
                    <SectionColabs>
                        <Title>Adicionar Colaboradores</Title>

                        <Row>
                            <input
                                type="text"
                                placeholder="Digite a matrícula"
                                maxLength={6}
                                value={matricula}
                                onChange={(e) => { setMatricula(e.target.value) }}
                            />
                            <ContainerIconSearch>
                                <IconeSearch onClick={fetchMatricula} />
                            </ContainerIconSearch>
                        </Row>
                        {
                            preview && (
                                <>
                                    <Preview>
                                        <strong>Confirme o colaborador:</strong><br />
                                        Nome: {previewColab.NOME}<br />
                                        Matrícula: {previewColab.MATRICULA}
                                    </Preview>
                                    <AddButton onClick={(e) => adicionarColab(e)} disabled={false}>
                                        ADICIONAR
                                    </AddButton>
                                </>
                            )
                        }
                        <List>
                            {selectedColabs.map((colab, index) => (
                                <Item key={index}>
                                    <span>{colab.MATRICULA} - {colab.NOME} </span>
                                    <button onClick={(e) => removerColab(e, colab.MATRICULA)}>
                                        Remover
                                    </button>
                                </Item>
                            ))}
                        </List>
                    </SectionColabs>
                    <FormComp
                        type="submit"
                        valor={"SALVAR"}
                    />
                </Formulario>
                {
                    fetchingMat && (
                        <Overlay state={true} >
                            <Modal size="sm" >
                                <SmallLoading text="CARREGANDO INFORMAÇÕES DO USUÁRIO..." />
                            </Modal>
                        </Overlay>
                    )
                }
                {
                    saving && (
                        <Overlay state={true} >
                            <Modal size="sm" >
                                <SmallLoading text="SALVANDO TREINAMENTOS..." />
                            </Modal>
                        </Overlay>
                    )
                }
            </Modal>
        </Overlay>
    )
}

export default AddTreinamentoModal;